import { FileKind } from "../../../../define/FileKind";
import { BaseLocalListData } from "../../base/BaseLocalListData";

/** 数据 */
class BuildData{
    /** id */
    id: string = '';
    /** 等级 */
    lv: number = 0;
}

export default class MansionBuildData extends BaseLocalListData {
    lists = new Map<string, BuildData>();
   
    protected localKey: string = FileKind.SaveLocalDataKey.MANSION_BUILD_DATA;

    createItem(key: string): BuildData {
        return this.createItemT<BuildData>(BuildData, key);
    }
   
}
